import React from 'react';
import { i18n, IValuationData } from './ValuationWidget';
import styles from './Input.scss';
import TextField, { ITextFieldProps } from '../MaterialUi/TextField';

// export type IInputProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> & {
// export type IInputProps = Omit<ITextFieldProps, 'onChange'> & {
export type IInputProps = {
    name: keyof IValuationData;
    value: string;
    onChange: (name: keyof IValuationData, value: string) => void;
    label?: string;

    // // not needed with ITextFieldProps
    // className?: string;
    // required?: boolean;
    // type?: 'color' | 'date' | 'datetime-local' | 'email' | 'month' | 'number' | 'password' | 'search' | 'tel' | 'text' | 'time' | 'url' | 'week'; // | 'file' | 'range' | 'hidden' | 'submit';
    className?: ITextFieldProps['className'];
    required?: ITextFieldProps['required'];
    type?: ITextFieldProps['type']; // 'color' | 'date' | 'datetime-local' | 'email' | 'month' | 'number' | 'password' | 'search' | 'tel' | 'text' | 'time' | 'url' | 'week'; // | 'file' | 'range' | 'hidden' | 'submit';
    inputMode?: ITextFieldProps['inputMode'];
    pattern?: ITextFieldProps['pattern'];
};

const Input: React.FC<React.PropsWithChildren<IInputProps>> = ({ value, onChange, name, className = null, label = '', required = false, type = null, inputMode, pattern, ...props }) => {
    return (
        <div className={[className, styles.valuationInput].join(' ')}>
            <TextField
                // key="postCode"
                name={name}
                value={value || ''}
                onChange={(ev) => {
                    onChange(name, ev.target.value);
                }}
                label={label}
                required={required}
                type={type}
                inputMode={inputMode}
                pattern={pattern}
                // {...props}
            />
        </div>
    );
};

export default Input;
